import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-snack-bar-template',
  templateUrl: './snack-bar-template.component.html',
  styleUrls: ['./snack-bar-template.component.scss'],
})
export class SnackBarTemplateComponent implements OnInit {
  @Input() type: string;
  @Input() message: string;
  @Input() closeButton: boolean;

  @Output() emitClose = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onClose() {
    this.emitClose.next();
  }
}
